export type ColumnDateProps = {
  date: string;
};

const ColumnDate: React.FC<ColumnDateProps> = ({ date }) => {
  if (!date) {
    return null;
  }
  const [year, month, day] = date.split("-");
  const formattedDate = `${day}-${month}-${year}`;

  return (
    <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500 min-w-60">
      {formattedDate}
    </td>
  );
};

export default ColumnDate;
